import { UnstyledButton } from '@shared/ui/unstyled-button';
import { XmarkIcon } from '@shared/assets/icons';
import { useBodyScrollLock } from '@shared/hooks/useBodyScrollLock';
import { StylesSettings } from '@shared/types/types';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { ReactNode } from 'react';
import styles from './modal.module.scss';
import { Button } from '@shared/ui/kit';
import clsx from 'clsx';

interface ButtonProps {
  text: string;
  onClick?: () => void;
  isDisabled?: boolean;
  settings?: StylesSettings;
}

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  title?: string;
  applyButton?: ButtonProps;
  cancelButton?: ButtonProps;
  width?: number | string;
  className?: string;
  headerClassName?: string;
  footer?: ReactNode;
}

const footerButtonSettings = (settings?: StylesSettings): StylesSettings => ({
  height: anatomy['size-40'],
  minHeight: anatomy['size-40'],
  ...settings,
});

export const Modal = ({
  isOpen,
  onClose,
  children,
  title,
  applyButton,
  cancelButton,
  width = 'unset',
  className,
  headerClassName,
  footer,
}: ModalProps) => {
  useBodyScrollLock(isOpen);

  if (!isOpen) return;

  return (
    <div className={styles.overlay}>
      <div className={clsx(styles.content, className)} style={{ width }}>
        <div className={clsx(styles.header, headerClassName)}>
          {title}

          <UnstyledButton className={styles.xmarkIcon} onClick={onClose}>
            <XmarkIcon size="24" />
          </UnstyledButton>
        </div>

        {children}

        <div className={styles.footer}>
          {footer}

          <div className={styles.actions}>
            {cancelButton && (
              <Button
                variant="secondary"
                size="small"
                onClick={cancelButton.onClick || onClose}
                isDisabled={cancelButton.isDisabled}
                settings={footerButtonSettings(cancelButton.settings)}
              >
                {cancelButton.text}
              </Button>
            )}

            {applyButton && (
              <Button
                variant="accent"
                size="small"
                onClick={applyButton.onClick}
                isDisabled={applyButton.isDisabled}
                settings={footerButtonSettings(applyButton.settings)}
              >
                {applyButton.text}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
